<template>
    <div>
      <!-- NAVBAR -->
      <!-- <div v-for="tipo in tipos">{{tipo.tipo}}</div> -->
      <!-- HEADER -->
      <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
        <div class="container">
          <div class="header-body">
            <div class="row">
              <!-- CONTENIDO HEADER -->
                <div class="col-lg-7 col-md-10">
                  <h1 class="display-3 text-white">Bienvenido, {{user.name}}</h1>
                  <p class="text-white mt-0 mb-5">Estos son los departamentos a los que tienes acceso. Selecciona alguno para continuar.</p>
                  <router-link :to="{ name: 'account' }" class="btn btn-info">Mi Cuenta</router-link>
                  <button type="button" class="btn btn-secondary" @click="logout()">Cerrar sesión</button>
                </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="container mt--7">
        <div class="row">
          <div class="col-lg-3 col-md-4" v-for="d in departments" :key="d.id">
              <div class="card mb-20 shadow">
                <div class="pr-5 pl-5 pt-3">
                <img class="card-img-top" style="opacity:.2" src="https://s3-ap-southeast-2.amazonaws.com/resource.csnstatic.com/retail/globals/logo/v5/chileautos.png" alt="Departamento">

                </div>
                <div class="card-body text-center">
                  <h5 class="card-title text-uppercase">{{d.caption}}</h5>
                  <router-link :to="{name: d.name, params:{slug: d.url}}" class="btn btn-outline-primary">Ir ahora</router-link>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Auth from "@/helpers/middleware";
export default {
  data() {
    return {
      user: Auth.getUser(),
      departments: Auth.getDepartments()
    };
  },
  methods:{
    logout(){
      Auth.logOut()
    }
  }
};
</script>
